module.exports = __webpack_public_path__ + "img/IMG_8927.c7ed9137.jpg";